import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EntityType } from '@shared/models/entity-enum';
import { DataObject } from '@shared/models/data-object.model';
import { isEntityActive } from '@records/controls/utils/functions';

@Component({
  selector: 'miq-export-limits-dialog',
  templateUrl: './export-limits-dialog.component.html',
  styleUrls: ['./export-limits-dialog.component.scss'],
  standalone: false,
})
export class ExportLimitsDialogComponent implements OnInit {
  exportLimitsFormGroup: UntypedFormGroup;
  exportLimits: DataObject;
  entities: EntityType[];

  constructor(
    public dialogRef: MatDialogRef<ExportLimitsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DataObject,
    private formBuilder: UntypedFormBuilder
  ) {
    this.exportLimits = this.data.exportLimits;
    this.entities = this.data.entities;
  }

  ngOnInit() {
    this.exportLimitsFormGroup = this.formBuilder.group({
      property: this.getEntityControl(EntityType.Property),
      availability: this.getEntityControl(EntityType.Availability),
      lease: this.getEntityControl(EntityType.LeaseComp),
      sale: this.getEntityControl(EntityType.SaleComp),
      portfoliosale: this.getEntityControl(EntityType.PortfolioSale),
      tim: this.getEntityControl(EntityType.Tim),
      company: this.getEntityControl(EntityType.Company),
      contact: this.getEntityControl(EntityType.Contact),
      tenancy: this.getEntityControl(EntityType.Tenancy),
      brand: this.getEntityControl(EntityType.Brand),
      stackingplan: [this.exportLimits.stackingplan || '', Validators.required],
    });
  }

  private getEntityControl(entity: EntityType) {
    return isEntityActive(entity)
      ? [this.exportLimits[entity] ?? '', Validators.required]
      : [this.exportLimits[entity] ?? 0];
  }

  public submitChange() {
    this.dialogRef.close(this.exportLimitsFormGroup.value);
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  // form controls getters
  public get availability() {
    return this.exportLimitsFormGroup.get('availability');
  }
  public get lease() {
    return this.exportLimitsFormGroup.get('lease');
  }
  public get sale() {
    return this.exportLimitsFormGroup.get('sale');
  }
  public get portfoliosale() {
    return this.exportLimitsFormGroup.get('portfoliosale');
  }
  public get property() {
    return this.exportLimitsFormGroup.get('property');
  }
  public get tim() {
    return this.exportLimitsFormGroup.get('tim');
  }
  public get company() {
    return this.exportLimitsFormGroup.get('company');
  }
  public get contact() {
    return this.exportLimitsFormGroup.get('contact');
  }
  public get tenancy() {
    return this.exportLimitsFormGroup.get('tenancy');
  }
  public get brand() {
    return this.exportLimitsFormGroup.get('brand');
  }

  public get stackingplan() {
    return this.exportLimitsFormGroup.get('stackingplan');
  }
}
